import { Proposition } from "@hubcapp/types";

export const isDormantFranchise = ({ name }: Proposition) =>
  name.toLowerCase().startsWith("dormant");
